import { useContractorAddressSearch } from "./AddressSearch";
import { MultiSelectSearcher } from "../Abstractions/MultiSearcher/MultiSearcher";

export function AddressMultiSelect({ label, name, addressesField, readonly, required = true }) {
  const { items, onSearchChange } = useContractorAddressSearch({ addressesField });

  return (
    <div className="mb-2">
      <MultiSelectSearcher
        name={name}
        label={label}
        items={items}
        onSearchChange={onSearchChange}
        optionsObject={{ key: "id", value: "name" }}
        placeholder="Wyszukaj adres po nazwie..."
        optionSave={x => x.id}
        required={required}
        saveWholeObject
        readonly={readonly}
      />
    </div>
  );
}